// 企业中心 - menu
import Layout from '@/layout'
// 1 管理员
// 2 销售
// 3 代理商
// 4 运营
export default [
  {
    path: '',
    component: Layout,
    meta: {
      title: '统计中心',
      icon: 'zhuye',
      isshow: true,
      roles: ['1', '2', '3', '4']
    }
  },
  {
    path: '/',
    redirect: '/manage',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'kehuguanli-copy',
      isshow: false,
      roles: ['1', '2', '3', '4']
    },
    children: [
      {
        path: 'userManage',
        component: () => import('@/views/manage/userManage'),
        meta: {
          title: '客户信息',
          isshow: false,
          roles: ['1', '2', '3', '4']
        }
      },
      // {
      //   path: 'behavior',
      //   name: 'behavior',
      //   component: () => import('@/views/manage/behavior'),
      //   meta: { title: '行为分析',hidden:true }
      // },
      {
        path: 'manageDetail',
        component: () => import('@/views/manage/manageDetail')
      },
      {
        path: 'manageRenewal',
        component: () => import('@/views/manage/addRenewal')
      }
    ]
  },

  {
    path: '/operation',
    // name:'operation',
    component: Layout,
    meta: {
      title: '后台运营',
      icon: 'yunyingguanli',
      isshow: false,
      roles: ['1', '3', '4']
    },
    children: [
      {
        path: 'openUser',
        component: () => import('@/views/operation/openUser'),
        meta: {
          title: '注册开户',
          roles: ['1', '3', '4']
        }
      }
    ]
  },
  {
    path: '/system',
    name: 'systemList',
    component: Layout,
    meta: {
      title: '系统用户',
      icon: 'chengyuanyonghuguanli',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'systemList',
        component: () => import('@/views/system/index'),
        meta: {
          title: '系统用户',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/data',
    component: Layout,
    meta: {
      title: '数据字典',
      icon: 'shujuzidian',
      isshow: false,
      roles: ['1', '4']
    },
    children: [
      {
        path: 'dataList',
        component: () => import('@/views/data/index'),
        meta: {
          title: '数据字典',
          isshow: false,
          roles: ['1', '4']
        }
      },
      {
        path: 'dataDetail',
        component: () => import('@/views/data/dataDetail')
      }
    ]
  },
  {
    path: '/line',
    component: Layout,
    meta: {
      title: '线路申请',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/line/index'),
        meta: {
          title: '线路申请',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/menu',
    component: Layout,
    meta: {
      title: '菜单权限',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'menuAuth',
        component: () => import('@/views/menu/index'),
        meta: {
          title: '菜单权限',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/official',
    component: Layout,
    meta: {
      title: '官网咨询',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'officialWebsiteConsulting',
        component: () => import('@/views/customerConsultation/index'),
        meta: {
          title: '官网咨询',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/taskSet',
    component: Layout,
    meta: {
      title: '配置任务',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'taskSet',
        component: () => import('@/views/taskSet/index.vue'),
        meta: {
          title: '配置任务',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/log',
    component: Layout,
    meta: {
      title: '调度日志',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'taskLog',
        component: () => import('@/views/log/index.vue'),
        meta: {
          title: '调度日志',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/industryTemplate',
    component: Layout,
    meta: {
      title: '行业模板',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: '/industryTemplateList',
        // name: 'template',
        component: () => import('@/views/industryTemplate/index.vue'),
        meta: {
          title: '行业模板',
          isshow: false,
          roles: ['1']
        }
      },
      {
        path: '/createTemplate',
        name: 'addTemplate',
        component: () => import('@/views/industryTemplate/createTemplate')
      }
    ]
  },
  {
    path: '/dataEntry',
    component: Layout,
    meta: {
      title: '数据录入',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'entryLog',
        component: () => import('@/views/dataEntry/index.vue'),
        meta: {
          title: '数据录入',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/dataUpdate',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: 'dataUpdate',
        component: () => import('@/views/dataUpdate/index.vue'),
        meta: {
          title: '数据更新',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/knowledgeBaseSystem',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        name: 'kbs',
        path: '/knowledgeBaseSystem',
        component: () => import('@/views/knowledgeBaseSystem/index.vue'),
        meta: {
          title: '智能搜索知识库',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/feedBack',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: '/feedBackCenter',
        component: () => import('@/views/feedBack/index.vue'),
        meta: {
          title: '智能搜索反馈',
          isshow: false,
          roles: []
        }
      }
    ]
  },
  {
    path: '/hotSet',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ['1']
    },
    children: [
      {
        path: '/hotSetCenter',
        component: () => import('@/views/hotSet/index.vue'),
        meta: {
          title: '智能搜索热门配置',
          isshow: false,
          roles: []
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/permissionRouter.js